export enum ROUTE_URL {
  ROOT = '/',
  HOME = 'home',
  LOGIN = 'user/login',
  SIGNUP = 'user/signup',
  QUICK_SIGNUP = 'user/quick-signup',
  PROFILE_PAGE = 'profile',
  PROFILE_BETS= 'profile/bets',
  PROFILE_MENU_MOBILE = 'profile/menu',
}
